import { DeviceTagKnown } from '../../Pages/ManageTags/TagsTable';

export function DeviceCountCell({
  deviceTags,
}: {
  deviceTags: DeviceTagKnown[];
}): string {
  let output;
  const serialNumbers = deviceTags
    .filter((dT) => dT.serialNumber)
    .map((dT) => dT?.serialNumber);
  if (serialNumbers.length === 0) {
    output = '(0 Devices)';
  }
  if (serialNumbers.length === 1) {
    output = `(1 Device) ${serialNumbers[0]}`;
  }
  if (serialNumbers.length > 1) {
    output = `(${serialNumbers.length} Devices) ${serialNumbers.join(', ')}`;
  }
  if (serialNumbers.length > 6) {
    output = `(${serialNumbers.length} Devices) ${serialNumbers
      .slice(0, 5)
      .join(', ')}...`;
  }

  return output ?? '';
}
